import {randomString} from '../../../../libs/shared/helpers/src/utilities/stringHelpers';

export type WithClientId<T> = T & {clientId: string};

export function decorateWithClientId<T extends Object>(t: T): WithClientId<T> {
  return {...t, clientId: randomString(8)};
}
